import React from 'react';
import proptypes from 'prop-types';
const { bool } = proptypes;
import { FulfillmentPlaceholderStencil } from './FulfillmentPlaceholderStencil';

const FulfillmentPlaceholder = ({ isMajorAppliances = false }) => {

  return <FulfillmentPlaceholderStencil isMajorAppliances={isMajorAppliances} />;

};

FulfillmentPlaceholder.propTypes = {
  isMajorAppliances: bool
};

export { FulfillmentPlaceholder };
